import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/index.js
// module id = 638
// module chunks = 0